import { Breadcrumb, Link, Text } from "@/atoms"
import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import { HeaderPage } from "@/organisms/HeaderPage"
import {
  FormSlack,
  TestSlackButton
} from "@/pages/IntegrationsPage/components/molecules/FormSlack"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { useSlackAPI } from "@/pages/IntegrationsPage/hooks/useSlackAPI"
import { PageWithBreadcrumbTemplate } from "@/templates/PageWithBreadcrumbTemplate"
import { ConnectIntegrationFooter } from "../ConnectIntegrationPage/ConnectIntegrationFooter"

import styles from "./SlackIntegrationPage.module.scss"

export const SlackIntegrationPage = () => {
  const { t } = useTranslation()
  const vendor = INTEGRATION_VENDORS.slack
  const [_, { onRemove: _onRemove, ...formProps }] = useIntegration({ vendor })
  const slackApi = useSlackAPI(formProps)
  const title = t("integrations.slack.title")

  return (
    <PageWithBreadcrumbTemplate
      full
      header={
        <HeaderPage
          title={
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link to="/integrations">
                      {t("navigation.integrations")}
                    </Link>
                  )
                },
                {
                  title: (
                    <Link to={formProps.getBackToIntegrationUrl()}>Slack</Link>
                  )
                },
                { title }
              ]}
            />
          }
        />
      }
      footer={
        <ConnectIntegrationFooter
          disabled={!formProps.isDirty || slackApi.isTesting}
          isLoading={slackApi.isPending}
          okText={t("integrations.slack.form.buttons.add")}
          okProps={{ form: slackApi.formId, htmlType: "submit" }}
          onCancel={() => formProps.backToIntegration()}
        >
          <TestSlackButton
            form={formProps.form}
            t={formProps.t}
            onTest={slackApi.onTest}
            isTesting={slackApi.isTesting}
            isPending={slackApi.isPending}
          />
        </ConnectIntegrationFooter>
      }
    >
      <div className={styles.title}>
        <Heading level={4} title={title} />
        <Text type="secondary">{t("integrations.slack.form.description")}</Text>
      </div>
      <FormSlack
        formId={slackApi.formId}
        onFinish={slackApi.onFinish}
        {...formProps}
      />
    </PageWithBreadcrumbTemplate>
  )
}
